module.exports = "static/assets/589eaf6a247df5343b584fd0fa848489.svg";